const Languages = {
  'ar-AE': 'عربى',
  'bg-BG': 'Bulgarian',
  'cs-CZ': 'Češtině',
  'da-DK': 'Dansk',
  bg: 'Bulgarian',
  cs: 'Češtině',
  da: 'Dansk',
  de: 'Deutsche',
  'el-GR': 'Greek',
  'en-GB': 'English (UK)',
  el: 'Greek',
  en: 'English (US)',
  'es-ES': 'Español (España)',
  es: 'Español (Latinoamérica)',
  'fi-FI': 'suomi',
  'fr-CA': 'Français (Canada)',
  'fr-FR': 'Français (France)',
  'hi-IN': 'हिन्दी',
  'he-IL': 'עִברִית',
  'hu-HU': 'Magyar',
  'id-ID': 'Indonesian',
  fi: 'suomi',
  fr: 'Français',
  hi: 'हिन्दी',
  he: 'עִברִית',
  hu: 'Magyar',
  id: 'Indonesian',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  'ms-MY': 'Bahasa Melayu',
  'nl-NL': 'Nederlanda',
  'pl-PL': 'Polskie',
  'pt-BR': 'Português (Brasil)',
  'ro-RO': 'Romanian',
  ms: 'Bahasa Melayu',
  nl: 'Nederlanda',
  pl: 'Polskie',
  pt: 'Português',
  ro: 'Romanian',
  ru: 'Русский',
  'sk-SK': 'Slovak',
  'sl-SI': 'Slovenian',
  'sr-RS': 'Serbian',
  'sv-SE': 'Svenska',
  'th-TH': 'ไทย',
  'tl-PH': 'Tagalog',
  'tr-TR': 'Türkçe (Türkiye)',
  'uk-UA': 'украї́нська мо́ва',
  'vi-VN': 'Tiếng Việt',
  'zh-CN': '中文简体 (普通话)',
  'zh-TW': '中文繁體（普通話)',
  sk: 'Slovak',
  sl: 'Slovenian',
  sr: 'Serbian',
  sv: 'Svenska',
  th: 'ไทย',
  tl: 'Tagalog',
  tr: 'Türkçe (Türkiye)',
  uk: 'украї́нська мо́ва',
  vi: 'Tiếng Việt',
  zh: '中文简体',
};
export default Languages;
